import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { FileUpload } from '../fileupload';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { finalize } from 'rxjs/operators';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { UploadFileService } from '../upload-file.service';
import { NotificationService } from 'src/app/shared/services/notification.service';


@Component({
  selector: 'app-form-upload-multiple-reply',
  templateUrl: './form-upload-multiple-reply.component.html',
  styleUrls: ['./form-upload-multiple-reply.component.css'],
  inputs: ['idBot', 'botName', 'uploadfilePath', 'imagelink', 'showSize', 'ShowCardURL', 'editMode']
})
export class FormUploadMultipleReplyComponent implements OnInit {

  selectedFiles!: FileList;
  currentFileUpload!: FileUpload;
  progress: { percentage: number } = { percentage: 0 };
  botImageURL!: boolean;
  download!: boolean;
  downloadURL: any;
  showSize;
  uploadfilePath;
  link: any;
  editMode
  image;
  imagelink: any;
  idBot;
  botName
  ShowCardURL
  showURL = false
  isUploading: boolean = false;
  @Output() urlImageCard = new EventEmitter();
  @Output() showURLInput = new EventEmitter();
  constructor(private uploadService: UploadFileService,
    private storage: AngularFireStorage,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
  }

  selectFile(event) {
    this.selectedFiles = event.target.files;
    this.upload();
  }
  URLInput() {
    this.showURL = !this.showURL
    this.showURLInput.emit(this.showURL);
  }
  upload() {
    const file = this.selectedFiles.item(0)!;
    // this.selectedFiles = '';
    this.currentFileUpload = new FileUpload(file);
    this.botImageURL = false;
    this.download = true;
    this.isUploading = true;
    const filePath = this.uploadfilePath;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.percentageChanges().subscribe(percentage => {
      this.progress.percentage = Math.round(percentage ? percentage : 0);
    });

    task.snapshotChanges().pipe(
      finalize(() => {
        this.downloadURL = fileRef.getDownloadURL();
        this.isUploading = false;
      })
    )
      .subscribe({
        next: (image) => {
          this.link = fileRef.getDownloadURL().subscribe(tt => {
            this.imagelink = tt;
            if (this.imagelink)
              this.urlImageCard.emit(this.imagelink);
          });
        },
        error: (error) => {
          this.notificationService.showError('Upload error:');
          this.isUploading = false;
        }
      })
  }
}
